<template>
  <vf-modal class="z-above-header" class-content="p-0" size="full">
    <vf-button :aria-label="$t.close" class="absolute right-0 top-0 z-1 mr-4 mt-4 p-3" @click="$emit('close')">
      <vf-icon name="close" size="md" />
    </vf-button>

    <base-carousel class="h-full f-col center" class-container="full" class-wrapper="full">
      <template #default="{ active }">
        <slot :active />
      </template>
      <template #prev="{ active, action }">
        <vf-button
          :aria-label="$t.previousSlide"
          class="z-1 mr-4 rounded-full p-3 -mt-8"
          :class="classButtonPrevious"
          :disabled="!active"
          @click="action"
        >
          <vf-icon dir="left" name="arrow" size="md" />
        </vf-button>
      </template>

      <template #next="{ active, action }">
        <vf-button
          :aria-label="$t.nextSlide"
          class="z-1 mr-4 mt-8 rounded-full p-3"
          :class="classButtonNext"
          :disabled="!active"
          @click="action"
        >
          <vf-icon name="arrow" size="md" />
        </vf-button>
      </template>

      <template #pagination="{ active, pages }">
        <vf-progress-bar class="absolute bottom-0 mx-a my-6 w-1/2 md:my-8" :max="pages" :value="active + 1" />
      </template>
    </base-carousel>

    <p v-if="title" class="absolute title-4 <md:hidden" :class="classTitle" style="top:2rem;left:1.875rem">
      {{ title }}
    </p>
  </vf-modal>
</template>

<script lang="ts" setup>
import type { CSSClass } from '#types/common'

defineProps<{
  title?: string
  classTitle?: CSSClass
  classButtonPrevious?: CSSClass
  classButtonNext?: CSSClass
}>()

defineEmits<{
  close: []
}>()
</script>
